export default __webpack_public_path__ + "static/media/raja_seat.8b826616.jpg";